.q{flex-direction:row;}